import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
  AuthGuard,
  AuthoritiesGuard,
  AuthGuardLogged
} from './domains/auth/guards';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
    import('./features/login/login.module').then(m => m.LoginModule),
    canActivate: [AuthGuardLogged]
  },{
    path: 'dashboard',
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(
        m => m.DashboardModule
      ),
    canActivate: [AuthGuard, AuthoritiesGuard]
  },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
